import { getAuth, signInWithEmailAndPassword, signOut, createUserWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { collection, where, getDocs, query } from "firebase/firestore";
import { db } from './firebaseInit';

export const auth = getAuth();

export const createUser = async (email) => {
    let userData = null;
    try {
        userData = await createUserWithEmailAndPassword(auth, email, Math.random().toString(36).slice(2, 10));
        await sendPasswordResetEmail(auth, email);
    } catch {
        userData = null;
    };
    return userData;
}

export const login = async (email, password) => {
    return await signInWithEmailAndPassword(auth, email, password);
}

export const logout = async () => {
    return await signOut(auth);
}

export const resetPassword = async (email) => {
    return sendPasswordResetEmail(auth, email);
}

export const vendorLogin = async (phone, pass) => {
    const q = query(collection(db, "vendor"), where("phone", "==", phone), where("password", "==", pass));
    const result = [];
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
        //console.log(doc.id, " => ", doc.data());
        result.push({ id: doc.id, data: doc.data() });
    });
    if(result.length>0){
        auth.token = result[0].data;
    }
    return result.length>0? result[0].data: null;
}

export const deliveryLogin = async (phone, pass) => {
    const q = query(collection(db, "delivery"), where("phone", "==", phone), where("password", "==", pass));
    const result = [];
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
        //console.log(doc.id, " => ", doc.data());
        result.push({ id: doc.id, data: doc.data() });
    });
    return result.length>0? result[0].data: null;
}

